import { Button, Box, Stack, Divider } from "@mui/material";
import { navigatorAPIUrl, APP_NAME } from "src/utils/constants";
import { useAppSelector } from "src/hooks";
import GoogleLogo from "src/images/google-signin.png";
import MSLogo from "src/images/microsoft-logo.png";

interface Props {
    divider?: boolean;
}

const SSO = ({ divider = false }: Props) => {
    const agencyId = useAppSelector((state) => state.auth.config?.agencyId);

    return (
        <Stack spacing={2} sx={{ mt: 4, width: "100%" }}>
            <Button
                variant="outlined"
                fullWidth
                sx={{ p: 0 }}
                href={`${navigatorAPIUrl}/auth/oauth2/connect/${APP_NAME}/google${
                    agencyId ? `/${agencyId}` : ""
                }`}
            >
                <Box
                    component="img"
                    alt="logo"
                    src={GoogleLogo}
                    sx={{
                        height: 50,
                        objectFit: "contain",
                        p: 1.5,
                    }}
                />
            </Button>
            <Button
                variant="outlined"
                fullWidth
                sx={{ p: 0 }}
                href={`${navigatorAPIUrl}/auth/oauth2/connect/${APP_NAME}/microsoft${
                    agencyId ? `/${agencyId}` : ""
                }`}
            >
                <Box
                    component="img"
                    alt="logo"
                    src={MSLogo}
                    sx={{
                        height: 50,
                        objectFit: "contain",
                        p: 1.7,
                    }}
                />
            </Button>
            {divider && <Divider>or</Divider>}
        </Stack>
    );
};

export default SSO;
